import { Box } from "@mui/material";
import { ReactComponent as NonIdealIcon } from "./../../../../assets/icons/draft_non_ideal_icon.svg";
import { ParagraphText, UBButton } from "../../../../Libraries";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const SaleBookNonIdeal = ({
  icon = <NonIdealIcon />,
  title = "",
  subTitle = "",
  actionButtons,
  actionButton,
}) => {
  const buttons =
    Array.isArray(actionButtons) && actionButtons.length > 0
      ? actionButtons
      : actionButton
        ? [actionButton]
        : [];

  return (
    <Box className={styles.nonIdealContainer}>
      {icon}
      {title && <ParagraphText className={styles.title}>{title}</ParagraphText>}
      {subTitle && (
        <ParagraphText className={styles.subTitle}>{subTitle}</ParagraphText>
      )}
      {buttons.length > 0 && (
        <Box className={styles.actionButtons}>
          {buttons.map((btn, index) => (
            <UBButton
              key={btn.id ?? `${btn.title}-${index}`}
              id={btn.id}
              title={btn.title}
              className={btn.className ?? "ubSecondaryButton"}
              onClick={() => { triggerLogEvent(analytics, "pos_watch_tutorial", { button_id: btn.id }); (btn.onClick ?? (() => {}))(); }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default SaleBookNonIdeal;
